import Keymap from "./keymap"

const toggleMark = mark => (event, editor) => {
  editor.toggleMark(mark)
}

export default () =>
  Keymap({
    "mod+b": toggleMark("bold"),
    "mod+i": toggleMark("italic"),
    "mod+u": toggleMark("underline")
  })
